//react
import React from "react";

//router
import { Redirect } from "react-router-dom";

//redux
import { connect } from 'react-redux';

// styles
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "assets/jss/material-kit-pro-react/views/ecommerceStyle.jsx";
import classNames from "classnames";

// components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Parallax from "components/Parallax/Parallax.jsx";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

// sections for this page
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import SectionProducts from "views/EcommercePage/Sections/SectionProducts.jsx";

class EcommercePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      opacity: 0,
      searchQuery: ""
    };
    
    this.searchProducts = this.searchProducts.bind(this);
    this.resetQuery = this.resetQuery.bind(this);

  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }

  searchProducts(query) {
    this.setState({searchQuery: query});
  }

  resetQuery() {
    this.setState({searchQuery: ""});
  }

  render() {
    const { classes } = this.props;

    if (!this.props.user.orderingPermissions && this.props.user.userType !== 'admin' && this.props.user.userType !== 'Affiliate') {
      return <Redirect to='/login' />
    } 

    return (
      <div>
        <Header
          brand="All Things EQ"
          fixed
          links={<HeaderLinks dropdownHoverColor="info" onSearch={this.searchProducts} searchQuery={this.state.searchQuery} />}
          color="transparent"
          changeColorOnScroll={{
            height: 300,
            color: "dark"
          }}
        />
        <Parallax
          image={require("assets/img/teachers8.png")}
          filter="dark"
          small
        >
          
        </Parallax>

        <div className={classNames(classes.main, classes.mainRaised)} style={{paddingBottom:"50px"}}>
          
          <div className={classes.container} style={{paddingTop:"30px"}}>
            <GridContainer>
              <GridItem xs={12}>
                <h2>Shirts and Stuff</h2>
              </GridItem>
            </GridContainer>
          </div>

          <SectionProducts searchQuery={this.state.searchQuery} resetQuery={this.resetQuery} />
        </div>
        
        <Footer content={
            <div>
              <div className={classes.left}>
                <List className={classes.list}>
                  <ListItem className={classes.inlineBlock}>
                    <a
                      href="https://app.allthingseq.com/"
                      className={classes.block}
                    >
                      All Things E.Q.
                    </a>
                  </ListItem>
                  
                </List>
              </div>
              <div className={classes.right} style={{fontSize:"12px", marginRight:"23px"}}>
                &copy; {1900 + new Date().getYear()}{" "}
                AVA School Solutions
              </div>
            </div>
          }/>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return state;
}

EcommercePage = connect(mapStateToProps)(EcommercePage);
export default withStyles(styles)(EcommercePage);




// WEBPACK FOOTER //
// ./src/views/EcommercePage/EcommercePage.jsx